<template>
  <div>
    <div class="content">
      <p style="font-size: 16px;font-family: '苹方';font-weight: bold;margin-bottom: 15px;">{{ $t('center.Hotel_bill') }}
      </p>
      <div style="background-color: #f6f6f6; height: 76px;border: 1px solid #e7e7e7;">
        <div class="search-item">
          <p style="padding-left: 10px;color: #676767;font-size: 12px;margin-bottom: 5px;">{{
            $t('cashier.order_num')
          }}:
          </p>
          <el-input v-model="searchForm.orderNum" :placeholder="$t('center.fill_in_order_num')" clearable
            style="width: 200px; margin-left: 10px" size="mini"></el-input>
        </div>
        <div class="search-item">
          <p style="padding-left: 10px;color: #676767;font-size: 12px;margin-bottom: 5px;">交易类型:</p>
          <el-select v-model="searchForm.transactionType" placeholder="请选择" size="mini"
                     style="margin-left: 5px;width: 130px" clearable>
            <el-option :value="1" label="授信额度" />
            <el-option :value="2" label="充值" />
            <el-option :value="3" label="临时额度" />
            <el-option :value="4" label="人工调整" />
            <el-option :value="5" label="临时额度撤销" />
            <el-option :value="6" label="消费" />
            <el-option :value="7" label="退款" />
          </el-select>
        </div>
        <div class="search-item deal-time">
          <p style="padding-left: 10px;color: #676767;font-size: 12px;margin-bottom: 5px;">
            {{ $t('center.Transaction_time') }}:</p>
          <el-select v-model="searchForm.timeType" placeholder="请选择" size="mini"
            style="margin-left: 10px; margin-right: 5px">
            <el-option :label="$t('center.year')" :value="1"></el-option>
            <el-option :label="$t('center.month')" :value="2"></el-option>
            <el-option :label="$t('center.day')" :value="3"></el-option>
          </el-select>
          <el-date-picker v-show="searchForm.timeType == 1" v-model="searchForm.year" type="year"
            :placeholder="$t('center.Select_Year')" value-format="yyyy" size="mini" :clearable="false">
          </el-date-picker>
          <el-date-picker v-show="searchForm.timeType == 2" v-model="searchForm.month" type="monthrange"
            :range-separator="$t('booking.to')" :start-placeholder="$t('center.Start_date')"
            :end-placeholder="$t('center.End_date')" value-format="yyyy-MM" size="mini" :clearable="false">
          </el-date-picker>
          <el-date-picker v-show="searchForm.timeType == 3" v-model="searchForm.day" type="daterange"
            :range-separator="$t('booking.to')" :start-placeholder="$t('center.Start_date')"
            :end-placeholder="$t('center.End_date')" value-format="yyyy-MM-dd" size="mini" :clearable="false">
          </el-date-picker>
        </div>
        <div class="search-item">
          <el-button type="primary" style="width: 100px;margin-top: 16px;" @click="onSearch" size="mini">
            {{ $t('search.searchBtn') }}
          </el-button>
        </div>
      </div>
      <el-table :data="bills" style="width: 100%; margin-top: 20px; font-size: 12px">
        <el-table-column prop="outerId" :label="$t('center.Cozytime_order')" width="200">
        </el-table-column>
        <el-table-column prop="chlOrderId" :label="$t('center.your_order')" width="200">
        </el-table-column>
        <el-table-column :label="$t('center.Payment_method')" width="200">
          <template slot-scope="scope">
            {{ paymentTypeMap[scope.row.paymentType] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.Transaction_type')" width="150">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.transactionType != 1">{{ transactionTypeMap[scope.row.transactionType] }}</span>
              <span v-else>{{ subTransactionMap[scope.row.subTransactionType] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('center.Order_amount')" width="150">
          <template slot-scope="scope">
            <div>{{ $commonUtil.formatPrice(scope.row.amount) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" :label="$t('center.Transaction_date')"> </el-table-column>
      </el-table>
      <div style="text-align: center; margin-top: 36px">
        <el-pagination background layout="prev, pager, next" :pager-count="5" @current-change="pageChange"
          @prev-click="pageChange" @next-click="pageChange" :total="searchForm.total" :page-size="searchForm.size"
          :current-page="searchForm.current" :hide-on-single-page="true">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchForm: {
        timeType: 1,
        partnerCode: this.$commonUtil.isLogin() ? parseInt(this.$commonUtil.getPartnerInfo().partnerCode) : 0,
        total: 0,
        size: 10,
        current: 1
      },
      bills: [],
      paymentTypeMap: {
        1: this.$t('center.Credit_line_payment'),
        2: this.$t('center.Alipay_payment'),
        3: this.$t('center.WeChat_payment')
      },
      transactionTypeMap: {
        1: this.$t('center.Recharge'),
        2: this.$t('center.Consumption'),
        3: this.$t('center.Refund')
      },
      subTransactionMap: {
        1: '授信额度',
        2: '充值',
        3: '临时额度',
        4: '人工调整',
        5: '临时额度撤销'
      }
    }
  },
  mounted () {
    // 时间初始化 todo
    this.onSearch()
    this.$commonUtil.modfiyicon()
  },
  activated () {
    this.$emit('updateWidth', 1340)
  },
  methods: {
    onSearch (type) {
      if (type != 1) {
        this.searchForm.current = 1
      }
      let vm = this
      let loading = vm.$loading({
        // lock: true,
        text: '努力加载中，请稍后.....',
        spinner: 'el-icon-loading',
        background: vm.$finalData.LoadingBgColorAll
      })
      let headers = { accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : '' }
      vm.$http.post('/b2b/searchB2BTransBill', vm.searchForm, {headers}).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.bills = result.data.billList
          vm.searchForm.total = result.data.total
        } else {
          vm.$message.error('错误：' + result.message)
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
        loading.close()
      })
    },
    pageChange (num) {
      this.searchForm.current = num
      this.onSearch(1)
    }
  }
}
</script>

<style lang="stylus" scoped>
.content {
  background-color: #fff;
  padding: 20px 20px 34px 20px;
}

.search-item {
  padding: 0 5px;
  padding-top: 15px;
  color: #a4a4a4;
  float: left;
  font-size: 14px;
}

>>> .el-table th {
  background-color: #f6f6f6;
  padding: 10px 0;
}

.deal-time >>> .el-select .el-input__inner {
  width: 75px;
}

.deal-time >>> .el-range-editor.el-input__inner {
  padding: 0 10px;
}

.deal-time >>> .el-range-editor--mini .el-range-separator {
  line-height: 27px;
}

.deal-time >>> .el-range-editor--mini.el-input__inner {
  height: 27px;
  width: 280px;
}

.deal-time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 280px;
}

.deal-time >>> .el-input--prefix .el-input__inner {
  padding-left: 120px;
}

>>> .el-button--primary:hover{
  background-color: #1e50f0;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/BillDeatil.vue